/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Logo_UpdatedInputs */

const en_logo_updated = /** @type {(inputs: Logo_UpdatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Logo updated`)
};

const es_logo_updated = /** @type {(inputs: Logo_UpdatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Logotipo actualizado`)
};

const fr_logo_updated = /** @type {(inputs: Logo_UpdatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Logo mis à jour`)
};

const de_logo_updated = /** @type {(inputs: Logo_UpdatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Logo aktualisiert`)
};

const ja_logo_updated = /** @type {(inputs: Logo_UpdatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ロゴが更新されました`)
};

const zh_logo_updated = /** @type {(inputs: Logo_UpdatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Logo 已更新`)
};

const ar_logo_updated = /** @type {(inputs: Logo_UpdatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تم تحديث الشعار`)
};

const id_logo_updated = /** @type {(inputs: Logo_UpdatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Logo diperbarui`)
};

const it_logo_updated = /** @type {(inputs: Logo_UpdatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Logo aggiornato`)
};

const ru_logo_updated = /** @type {(inputs: Logo_UpdatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Логотип обновлен`)
};

const pt_logo_updated = /** @type {(inputs: Logo_UpdatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Logotipo atualizado`)
};

const ko_logo_updated = /** @type {(inputs: Logo_UpdatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`로고가 업데이트되었습니다`)
};

/**
* | output |
* | --- |
* | "Logo updated" |
*
* @param {Logo_UpdatedInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const logo_updated = /** @type {((inputs?: Logo_UpdatedInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Logo_UpdatedInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_logo_updated(inputs)
	if (locale === "es") return es_logo_updated(inputs)
	if (locale === "fr") return fr_logo_updated(inputs)
	if (locale === "de") return de_logo_updated(inputs)
	if (locale === "ja") return ja_logo_updated(inputs)
	if (locale === "zh") return zh_logo_updated(inputs)
	if (locale === "ar") return ar_logo_updated(inputs)
	if (locale === "id") return id_logo_updated(inputs)
	if (locale === "it") return it_logo_updated(inputs)
	if (locale === "ru") return ru_logo_updated(inputs)
	if (locale === "pt") return pt_logo_updated(inputs)
	return ko_logo_updated(inputs)
});